import Rule from "../Rule";

export default class RuleOAEvaluationTypeRequiredWhenLeavingPASubmission extends Rule {
  static message =
    "Evaluation Type is required before moving from PA Submission.";

  run() {
    const currentOrderActivity =
      this.currentChartData.orderActivity[this.orderActivityId];
    const futureOrderActivity =
      this.futureChartData.orderActivity[this.orderActivityId];

    const approval = this.getApprovalForOrder(
      this.futureChartData,
      this.orderActivityId,
    );

    // Fail only when all are true:
    // 1) This is a New order
    // 2) The order is not already approved
    // 3) The user is moving from PA Submission to Preauth Followup, Preauth Followup - Appeals, or Approval
    // 4) Evaluation Type is missing on the linked approval
    if (
      currentOrderActivity?.orderType?.toLowerCase() === "new" &&
      currentOrderActivity?.isApproved !== true &&
      currentOrderActivity.orderStatusReasonId === 30 && // PA Submission
      [6, 89, 59].includes(futureOrderActivity.orderStatusReasonId) && // Preauth Followup, Preauth Followup - Appeals, Approval
      !approval?.evaluationTypeTermId
    ) {
      return this.fail();
    }

    return this.pass();
  }

  getApprovalForOrder(chartData, orderActivityId) {
    const linkedOrderActivityApproval = Object.values(
      chartData?.orderActivityApprovals || {},
    ).find(
      (orderActivityApproval) =>
        String(orderActivityApproval?.orderActivityId) ===
        String(orderActivityId),
    );

    return Object.values(chartData?.approval || {}).find(
      (approval) =>
        String(approval?.id) ===
        String(linkedOrderActivityApproval?.approvalsId),
    );
  }
}
